var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_406_13841)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 21C19 20.4477 19.4477 20 20 20H24.4648L26.1679 22.5547C26.3534 22.8329 26.6656 23 27 23H36C36.5523 23 37 23.4477 37 24V35C37 35.5523 36.5523 36 36 36H20C19.4477 36 19 35.5523 19 35V21ZM20 18C18.3431 18 17 19.3431 17 21V35C17 36.6569 18.3431 38 20 38H36C37.6569 38 39 36.6569 39 35V24C39 22.3431 37.6569 21 36 21H27.5352L25.8321 18.4453C25.6466 18.1671 25.3344 18 25 18H20ZM33.5155 30.2108C34.0678 30.2108 34.5155 29.7631 34.5155 29.2108C34.5155 28.6585 34.0678 28.2108 33.5155 28.2108H32.2206L28.1352 28.2108C27.9641 27.6606 27.6589 27.156 27.2411 26.7454C26.5832 26.0989 25.6976 25.7365 24.7752 25.7365C23.8527 25.7365 22.9672 26.0989 22.3093 26.7454C21.6514 27.392 21.2738 28.2711 21.2577 29.1934L21.2577 29.1934L21.2576 29.2041C21.2545 29.6681 21.3432 30.128 21.5186 30.5576C21.694 30.9871 21.9526 31.3777 22.2796 31.7069C22.6066 32.0361 22.9954 32.2973 23.4238 32.4756C23.8522 32.6539 24.3115 32.7457 24.7755 32.7457C25.2395 32.7457 25.6989 32.6539 26.1272 32.4756C26.5556 32.2973 26.9445 32.0361 27.2714 31.7069C27.5984 31.3777 27.857 30.9871 28.0324 30.5576C28.0788 30.444 28.1192 30.3282 28.1534 30.2108L31.2206 30.2108V31.1531C31.2206 31.7054 31.6683 32.1531 32.2206 32.1531C32.7729 32.1531 33.2206 31.7054 33.2206 31.1531L33.2206 30.2108H33.5155ZM25.8392 28.1719C26.1223 28.4501 26.2852 28.8275 26.2935 29.2228C26.2941 29.4212 26.2559 29.6178 26.1809 29.8015C26.1052 29.9869 25.9936 30.1554 25.8525 30.2974C25.7114 30.4395 25.5436 30.5522 25.3588 30.6291C25.1739 30.7061 24.9757 30.7457 24.7755 30.7457C24.5753 30.7457 24.3771 30.7061 24.1923 30.6291C24.0074 30.5522 23.8396 30.4395 23.6985 30.2974C23.5574 30.1554 23.4458 29.9869 23.3702 29.8015C23.2952 29.6178 23.2569 29.4212 23.2575 29.2228C23.2658 28.8268 23.4286 28.4496 23.7112 28.1719C23.9951 27.8929 24.3772 27.7365 24.7752 27.7365C25.1732 27.7365 25.5553 27.8929 25.8392 28.1719Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_13841",
    x1: 4.17656,
    y1: 1.48605e-7,
    x2: 55.7705,
    y2: 54.4613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B42196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52502,
    stopColor: "#6D85EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08AABC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.342e9a0b901078bb9c86c08ccc94c433.svg";
export { ForwardRef as ReactComponent };